export default "__VITE_ASSET__75fdab5a__"